import { FormTemplateRule } from '../templating/formTemplateRule'

export class SequentialValueRule extends FormTemplateRule {
/**
 * Creates an instance of SequentialValueRule.
 * @param {any} formFields The fields to apply the rule to.
 * @memberof SequentialValueRule
 */
  constructor (parameters) {
    /*
     * The callback to apply the rule to each submission in the pipeline.
     */
    const callback = function (submission, index, parameters) {
      const token = parameters.token
      const start = parseInt(token, 10)
      const value = index + start
      const submissionKeysToApplyTo = parameters.targetFieldIdentifiers

      if (submissionKeysToApplyTo) {
        submissionKeysToApplyTo.forEach(fieldId => this.replace(submission, fieldId, token, value), this)
      }

      return submission
    }

    super('Increment Values', callback, parameters, 'This rule replaces a token with increasing values, where it appears in the fields you choose.')
  }

  /**
   * Replaces the value in `submission` that is stored for the key,`fieldId`.
   *
   * @param {any} submission The submission to modify.
   * @param {any} fieldId The key to store the value for.
   * @param {any} token The token to replace.
   * @param {any} value The new value to replace.
   * @memberof SequentialValueRule
   */
  replace (submission, fieldId, token, value) {
    const oldValue = submission.fields[fieldId]
    const newValue = oldValue.replace(token, value)
    submission.fields[fieldId] = newValue
  }
}
